import { Box, Button, Grid, TextField } from '@mui/material'
import { useFormik } from 'formik'
import React from 'react'
import { GrPowerReset } from 'react-icons/gr'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as yup from "yup"
import { login } from '../../store/features/user/userSlice';
import { Send } from '@mui/icons-material'

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    let loginSchema = yup.object({
        email: yup.string().email("Email Should be valid").required("Email is Required"),
    })
    const formik = useFormik({
        initialValues: {
        email: "",
        },
        validationSchema: loginSchema,
        onSubmit: (values) => {
            dispatch(login(values))
        }
    })
    
    const handleNavigate = () => {
        navigate("/otp/verify")
    }

  return (
    <div className='bg-blue-950 border-blue-800 w-[350px] sm:w-[500px] mt-[150px] mb-12 mx-auto p-8 border rounded-md shadow-md'>
        <div className='flex justify-center flex-col items-center pb-4'>
            <GrPowerReset className='text-blue-800 text-xl font-semibold' />
            <p className='text-white text-xl font-semibold'>Find your account</p>
            <span className='text-white'>Enter your register email</span>
        </div>

        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
                <Grid item xs={12} >
                    <TextField
                        id='email'
                        name='email'
                        label='Email'
                        fullWidth
                        autoComplete='given-email'
                        onChange={formik.handleChange("email")}
                        value={formik.values.email}
                        onBlur={formik.handleBlur("email")}
                    />
                    <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                        {formik.touched.email && formik.errors.email ? (
                            <div>{formik.errors.email}</div>
                        ) : null}
                    </Box>
                </Grid>
                <Grid item xs={12} >
                    <Button
                        onClick={handleNavigate}
                        className='bg-[#9155FD] w-full'
                        type='submit'
                        variant='contained'
                        size='large'
                        sx={{padding: ".8rem 0", bgcolor: "#1e40af", "&:hover": {bgcolor: "#1e3a8a"}}}
                        endIcon={<Send />}
                    >
                        Send otp
                    </Button>
                </Grid>
            </Grid>
        </form>

        <div className='flex justify-center flex-col items-center pt-4'>
            <Button
                onClick={()=>navigate("/login")}
                variant='outlined'
                className='ml-5' size='small'
            >
                Back to Login
            </Button>
        </div>

    </div>
  )
}

export default ForgotPassword
